module.exports = __webpack_public_path__ + "media/assets/icons/sidebar_plus-2bcad446fd4bad7436860e5b2d29ce4d.svg";